
import { getFirestore, collection, query, where, getDocs, doc, getDoc, setDoc, addDoc } from "firebase/firestore";
import nopic from '../components/img/nopic.jpg';
import { getStorage, ref as storageRef, getDownloadURL, uploadBytes } from 'firebase/storage';

/**
 * Get all champs
 * @returns Champs array
 */
const getChamps = async () => {
    let champsArray = [];
    const db = getFirestore();
    const q = query(collection(db, "champs"), where('wasDeleted', '!=', true));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((champ) => {

        let localChamp = champ.data()
        localChamp.__key = champ.id

        /* Get date */
        let localDate = new Date(localChamp['data'])
        localChamp.dataToShow = localDate.getDate() + '/' + (localDate.getMonth() + 1) + '/' + localDate.getFullYear()

        /* Put no pic if champ hasn't img */
        if (localChamp.img === undefined)
            localChamp.img = nopic

        champsArray.push(localChamp)
    });

    return champsArray;
}

/**
 * Get a champ
 * @param {String} champId 
 * @returns A champ
 */
const getChamp = async (champId) => {
    const db = getFirestore();
    const docRef = doc(db, "champs", champId);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) return null;

    let localChamp = await { ...docSnap.data() };
    localChamp.id = await docSnap.id;

    return localChamp;
}

/**
 * Create a champ
 * @param {Object} champToCreate 
 * @param {File} champAddObjectFile 
 * @param {File} champAddObjectDoc 
 * @returns 
 */
const createChamp = async (champToCreate, champAddObjectFile, champAddObjectDoc) => {
    const db = getFirestore();
    const dbRef = collection(db, 'champs')

    try {
        const champ = await addDoc(dbRef, champToCreate);
        const storage = getStorage();

        // Put file in firebase
        if (champAddObjectFile) {
            const imageRef = storageRef(storage, 'champsPhotos/' + champ.id);

            await uploadBytes(imageRef, champAddObjectFile, { contentType: 'image/jpeg' });

            const fileUrl = await getDownloadURL(imageRef);

            const dbRefToUpdateFile = doc(db, 'champs', champ.id);
            await setDoc(dbRefToUpdateFile, { img: fileUrl }, { merge: true });
        }

        // Put doc in firebase
        if (champAddObjectDoc) {
            let docRef = storageRef(storage, 'champsDocs/' + champ.id);

            await uploadBytes(docRef, champAddObjectDoc);

            const docUrl = await getDownloadURL(docRef);

            const dbRefToUpdateDoc = doc(db, 'champs', champ.id);
            await setDoc(dbRefToUpdateDoc, { doc: docUrl }, { merge: true });
        }

        return {
            message: 'Campeonato criado com sucesso',
        }
    } catch (err) {
        return {
            error: true,
            message: err.message,
        }
    }
}

/**
 * Update a champ
 * @param {String} champId 
 * @param {Object} champToUpdate 
 * @param {File} champAddObjectFile 
 * @param {File} champAddObjectDoc 
 * @returns 
 */
const updateChamp = async (champId, champToUpdate, champAddObjectFile, champAddObjectDoc) => {
    const db = getFirestore();
    const dbRef = doc(db, 'champs', champId)

    try {
        await setDoc(dbRef, champToUpdate, { merge: true });
        const storage = getStorage();

        // Put file in firebase
        if (champAddObjectFile) {
            const imageRef = storageRef(storage, 'champsPhotos/' + champId);

            await uploadBytes(imageRef, champAddObjectFile, { contentType: 'image/jpeg' });

            const fileUrl = await getDownloadURL(imageRef);

            const dbRefToUpdateFile = doc(db, 'champs', champId);
            await setDoc(dbRefToUpdateFile, { img: fileUrl }, { merge: true });
        }

        // Put doc in firebase
        if (champAddObjectDoc) {
            let docRef = storageRef(storage, 'champsDocs/' + champId);

            await uploadBytes(docRef, champAddObjectDoc);

            const docUrl = await getDownloadURL(docRef);

            const dbRefToUpdateDoc = doc(db, 'champs', champId);
            await setDoc(dbRefToUpdateDoc, { doc: docUrl }, { merge: true });
        }

        return {
            message: 'Campeonato atualizado com sucesso',
        }
    } catch (err) {
        return {
            error: true,
            message: err.message,
        }
    }
}

/**
 * Delete a champ
 * @param {String} champId 
 * @returns null
 */
const deleteAChamp = async (champId) => {
    try {
        const db = getFirestore();
        const dbRef = doc(db, 'champs', champId);
        await setDoc(dbRef, { wasDeleted: true }, { merge: true });
        return true;
    } catch (e) {
        return false;
    }
}

export {
    getChamps,
    getChamp,
    createChamp,
    updateChamp,
    deleteAChamp,
}